import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,

    searchList: {
        hideDefaultBtn: true,
        searchRightSpan: '4',
        searchTxt: [
            {
                type: 'input',
                value: 'barcodeNo',
                span: 6,
                clearable: true,
                name: $translate('lang.E3202101280001', { defaultText: '条码字符串' })
            },
            {
                type: 'input',
                value: 'billNo',
                span: 6,
                name: $translate('lang.E3202101280002', { defaultText: '单据号' }),
                clearable: true
            },
            {
                type: 'input',
                value: 'itemCode',
                span: 6,
                name: $translate('lang.E3202101280003', { defaultText: '产品编码' }),
                clearable: true
            },
            {
                type: 'date',
                value: 'billDate',
                span: 6,
                name: $translate('lang.E3202101270011', { defaultText: '单据日期' }),
                clearable: true
            },
            {
                type: 'date',
                value: 'opTime',
                span: 6,
                name: $translate('lang.E3202101280005', { defaultText: '扫码时间' }),
                clearable: true
            },
            {
                type: 'select',
                value: 'batchNo',
                span: 6,
                clearable: true,
                name: $translate('lang.E3202207280004', { defaultText: '批次号' }),
                options: []
            },
            {
                type: 'category',
                value: 'isReadTheEnd',
                span: 8
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        sequence: true,
        showOtpColumnConfig: true,
        rowKey: 'id',
        height: 'calc( 100vh - 220px )', // 样式被穿透了
        columns: [
             {
                label: $translate('lang.E3202101280001', { defaultText: '条码字符串' }),
                align: 'center',
                prop: 'serialNumber',
                filter: true,
                require: true,
                fixed: 'left',
                sort: true,
                width: 200
            }, {
                label: $translate('lang.E3202101280032', { defaultText: '来源系统' }),
                align: 'center',
                prop: 'sourceSystem',
                filter: true,
                require: true,
                fixed: 'left',
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202201260001', { defaultText: '客户型号' }),
                align: 'center',
                prop: 'customerModel',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280038', { defaultText: '单据编码' }),
                align: 'center',
                prop: 'billNo',
                filter: true,
                require: true,
                sort: true,
                width: 200
            }, {
                label: $translate('lang.E3202101280037', { defaultText: '扫码日期' }),
                align: 'center',
                prop: 'scanDate',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280003', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'itemCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280013', { defaultText: '产品名称' }),
                align: 'center',
                prop: 'itemName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030010', { defaultText: '发货单位编码' }),
                align: 'center',
                prop: 'shipperCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030009', { defaultText: '发货单位名称' }),
                align: 'center',
                prop: 'shipperName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030008', { defaultText: '收货单位编码' }),
                align: 'center',
                prop: 'consigneeCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030007', { defaultText: '收货单位名称' }),
                align: 'center',
                prop: 'consigneeName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280029', { defaultText: '订单生产编码' }),
                align: 'center',
                prop: 'orderProductionCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202103030090', { defaultText: '品牌' }),
                align: 'center',
                prop: 'brand',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030006', { defaultText: '消费国' }),
                align: 'center',
                prop: 'consumerCountry',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030005', { defaultText: '柜号' }),
                align: 'center',
                prop: 'containerNumber',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030004', { defaultText: '产品细类' }),
                align: 'center',
                prop: 'productCategory',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202112160001', { defaultText: '出入库类型' }),
                align: 'center',
                prop: 'inoutType',
                filter: true,
                require: true,
                sort: true,
                width: 80
            }, {
                label: $translate('lang.E2202402030003', { defaultText: '发货单位类型' }),
                align: 'center',
                prop: 'shipTypeDict',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030002', { defaultText: '收货单位类型' }),
                align: 'center',
                prop: 'recTypeDict',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280028', { defaultText: '产品单位' }),
                align: 'center',
                prop: 'itemUnit',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280027', { defaultText: '扫码人名称' }),
                align: 'center',
                prop: 'scanBy',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101270011', { defaultText: '单据日期' }),
                align: 'center',
                prop: 'billDate',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280036', { defaultText: '生产日期' }),
                align: 'center',
                prop: 'prodDate',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280025', { defaultText: '流向写入日期' }),
                align: 'center',
                prop: 'creationDate',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202101280035', { defaultText: '最终节点' }),
                align: 'center',
                prop: 'isReadTheEnd',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202207280004', { defaultText: '批次号' }),
                align: 'center',
                prop: 'batchNo',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E3202103250012', { defaultText: '执行结果' }),
                align: 'center',
                prop: 'processFlag',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }, {
                label: $translate('lang.E2202402030001', { defaultText: '执行时间' }),
                align: 'center',
                prop: 'processDate',
                filter: true,
                require: true,
                sort: true,
                width: 120
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
